import Vue from "vue";
import { $api } from "@/services/api";
import moment from 'moment';
// import heic2any from "heic2any";

// import { $t } from '@/plugins/vue-i18n'
// import VueI18n from 'vue-i18n'

Vue.mixin({
  data: () => ({
    delay_mounted_1000: false,

    bindProps: {
      defaultCountry: "IT",
      preferredCountries: ['it','fr','de','es','at','ch'],
    },

    langs: [
      {
        label: "Español",
        value: "es"
      },
      {
        label: "Italiano",
        value: "it"
      },
      {
        label: "English",
        value: "en"
      },
    ],

    all_languages: [
      {value:"afrikaans", text: "Afrikaans"},
      {value:"albanese", text: "Shqipe"},
      {value:"amarico", text: "አማርኛ"},
      {value:"basco", text: "Euskera"},
      {value:"bengali", text: "বাংলা"},
      {value:"bielorusso", text: "беларуская мова"},
      {value:"birmano", text: "Birmano"},
      {value:"bretone", text: "Brezhoneg"},
      {value:"bulgaro", text: "български език"},
      {value:"catalano", text: "Catalano"},
      {value:"ceco", text: "čeština"},
      {value:"coreano", text: "한국"},
      {value:"corso", text: "Còrso"},
      {value:"croato", text: "Hrvatski"},
      {value:"danese", text: "Dansk"},
      {value:"ebraico", text: "Jewish"},
      {value:"esperanto", text: "Esperanto"},
      {value:"estone", text: "Eesti"},
      {value:"farsi", text: "فارسی‎"},
      {value:"fiammingo", text: "Fiammingo"},
      {value:"finlandese", text: "Suomen"},
      {value:"gaelico_scozzese", text: "Gàidhlig Albannach" },
      {value:"galiziano", text: "Galego"},
      {value:"gallese", text: "Cymraeg"},
      {value:"georgiano", text: "ქართული"},
      {value:"giapponese", text: "日本語"},
      {value:"greco", text: "ΕΛΛΗΝΙΚΗ"},
      {value:"hindi", text: "हिन्दी"},
      {value:"indonesiano", text: "Bahasa Indonesia"},
      {value:"irlandese", text: "Irish"},
      {value:"islandese", text: "íslenska"},
      {value:"kazaco", text: "Қазақ"},
      {value:"lettone", text: "Latviešu"},
      {value:"lituano", text: "Lietuvių"},
      {value:"lussemburghese", text: "Lëtzebuergesch"},
      {value:"macedone", text: "македонски јазик"},
      {value:"malese", text: "Malaysia"},
      {value:"malgascio", text: "Malagasy"},
      {value:"maltese", text: "Maltija"},
      {value:"nederlandese", text: "Nederlands"},
      {value:"norvegese", text: "Norsk"},
      {value:"olandese", text: "Hollands"},
      {value:"persiano", text: "فارسی"},
      {value:"polacco", text: "Polski"},
      {value:"portoghese", text: "Português"},
      {value:"quechua", text: "Quechua"},
      {value:"rumeno", text: "Românesc"},
      {value:"serbo", text: "српски"},
      {value:"slovacco", text: "Slovenský"},
      {value:"sloveno", text: "Slovenski"},
      {value:"svedese", text: "Svenska"},
      {value:"tailandese", text: "ไทย"},
      {value:"turco", text: "Türkçe"},
      {value:"ucraino", text: "український"},
      {value:"ungherese", text: "Magyar nyelv"},
      {value:"urdu", text: "اردو"},
      {value:"usbeco", text: "Ўзбек"},
      {value:"vietnamita", text: "tiếng Việt"},
      {value:"yiddish", text: "ייִדיש"},
      {value:"zulu", text: "Zulu"}
    ],

    altezza: { min: 139, max: 210 },
    taglia: { min: 35, max: 58 },
    scarpe: { min: 34, max: 50 },

    seno:{ min: 69, max: 110 },
    reggisenoTaglia:{ min: 0, max: 8 },
    vita:{ min: 39, max: 90 },
    fianchi:{ min: 69, max: 110 },



    reggisenoCoppa: {
          ticks: [ '', 'A', 'B', 'C', 'D', 'E', 'F'],
          value: ''
    },
    adult_age_date: moment().add(-18,"years").format("YYYY-MM-DD"),
  }),
  computed: {
    $api: () => $api,
    loading_data(){
      return this.$store.getters['getLoadingData']
    },
    capelli(){
      return [
        {label: this.$t('Non selezionato'), value: ''},
        {label: this.$t('Biondi'), value: 'Biondi'},
        {label: this.$t('Biondi/Castani'), value: 'Biondi/Castani'},
        {label: this.$t('Castani'), value: 'Castani'},
        {label: this.$t('Neri'), value: 'Neri'},
        {label: this.$t('Rossi'), value: 'Rossi'},
        {label: this.$t('Grigi'), value: 'Grigi'},
        {label: this.$t('Bianchi'), value: 'Bianchi'},
        {label: this.$t('altro_colore_capelli'), value: 'Altro colore'},
      ]
    },
    capelliTipologia(){
      return [
        {label: this.$t('Non selezionato'), value: ''},
        {label: this.$t('Ricci'), value: 'Ricci'},
        {label: this.$t('Lisci'), value: 'Lisci'},
        {label: this.$t('Mossi'), value: 'Mossi'},
        {label: this.$t('Rasati'), value: 'Rasati'},
        {label: this.$t('Calvi'), value: 'Calvi'},
      ]
    },
    occhi(){
      return [
        {label: this.$t('Non selezionato'), value: ''},
        {label: this.$t('Azzurri'), value: 'Azzurri'},
        {label: this.$t('Verdi'), value: 'Verdi'},
        {label: this.$t('Castani'), value: 'Castani'},
        {label: this.$t('Grigi'), value: 'Grigi'},
        {label: this.$t('Neri'), value: 'Neri'},
      ]
    },
    all_experiences(){
      return [
        {label:'expHostess', name: this.$t('Hostess / Steward Accoglienza')},
        {label:'expVolantinaggio', name: this.$t('Volantinaggio')},
        {label:'expBallerino', name: this.$t('Ballerino')},
        {label:'expBarman', name: this.$t('Barman / Barlady')},
        {label:'expImmagine', name: this.$t('Hostess / Steward Immagine')},
        {label:'expSfilate', name: this.$t('Modella/o per sfilate')},
        {label:'expFotomodello', name: this.$t('Fotomodella/o')},
        {label:'expAttore', name: this.$t('Attore / Attrice')},
        {label:'expShowroom', name: this.$t('Modella/o Showroom')},
        {label:'expPromoter', name: this.$t('Promoter / Sampling di prodotto')},
        {label:'expInterprete', name: this.$t('Interprete')},
        {label:'expAnimatore', name: this.$t('Ballerina/o Animazione Disco')},
        {label:'expSupervisor', name: this.$t('Tour Leader / Supervisor')},
        {label:'expStylist', name: this.$t('Stylist')},
        {label:'expAssisstant', name: this.$t('Assisstant')},
        {label:'expAllestitore', name: this.$t('Allestitore')},
        {label:'expCameriere', name: this.$t('Cameriera/e')},
        {label:'expDj', name: this.$t('Dj')},
        {label:'expDoorman', name: this.$t('Doorman')},
        {label:'expDriver', name: this.$t('Driver')},
        {label:'expMerchandiser', name: this.$t('Merchandiser')},
        {label:'expMakeup', name: this.$t('Make up / Hair Stylist')},
        {label:'expFotografo', name: this.$t('Fotografa/o')},
        {label:'expMusicista', name: this.$t('Musicista / Cantante')},
        {label:'expPresentatrice', name: this.$t('Presentatrice/tore')},
        {label:'expHair', name: this.$t('Hair')},
      ]
    },
    items_languages(){
      return [
        {label: this.$t('C2 - Madrelingua'), value: "4"},
        {label: this.$t('C1 - Ottimo'), value: "3"},
        {label: this.$t('B2 - Buono'), value: "2"},
        {label: this.$t('A2/B1 - Base'), value: "1"},
        {label: this.$t('Non conosco'), value: null},
     ]
    },
    error_required(){
      return this.$t('error_required')
    },
    validation_rules(){
      return {
        required_not0: value => (!!value && value !== "0" && value !== "" && value !== 0 ) || this.error_required,
        madrelingua: value => !!value || this.$t('error_madrelingua'),
        once_experience: value => !!value || this.$t('error_once_experience'),
        required: value => !!value || this.error_required,
  
        password: value => /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#.?&\-_])[A-Za-z\d@$!%*#.?&\-_]{8,}$/.test(value) || this.$t('error_password'),
        password_match: (pass, r_pass) => pass == r_pass || ((!pass || !r_pass) ? '' : this.$t('error_password_match')),
        email_match: (mail, r_mail) => mail == r_mail || ((!mail || !r_mail) ? '' : this.$t('error_email_match')),
  
        counter_30: value => !value || (value  && value.length) <= 30 || this.$t('error_counter_30'),
  
        dateDDMMYYYY: value => /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/\d{4}$/.test(value) || this.$t('error_dateDDMMYYYY'),
  
        integer: value => (Number.isInteger(parseInt(value)) && /^\d+$/.test(value)) || this.$t('error_integer'),
  
        // phone: value => value != '^(71|72|74|76|81|82|84|85|86|87|88|89)\\d{5}$' || 'phone',
        phone: value => /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-s./0-9]*$|^$|^\s$/.test(value) || this.$t('error_phone'),
        phone_match: (phone, phone_2) => phone.trim().replaceAll(" ","") != phone_2.trim().replaceAll(" ","") || this.$t('error_phone_match'),
        codice_fiscale: value => /^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$|^\s/.test(value) || this.$t('error_cf'),
  
        // decimal: value => /^\d+(.\d{1,2})?$/.test(value) && value.indexOf('.') !== -1 || 'Invalid decimal value.',
        can_decimal_2: value => /^\d+(\.\d{1,2})?$/.test(value) || this.$t('error_can_decimal_2'),
  
        found: (found,text=this.$t('error_found_text_default')) => !found || text,
        
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || this.$t('error_email')
        },
      }
    }
  },
  methods: {
    workTiming(work){

      console.log("work", work);

      let today = moment().format("YYYY-MM-DD")
      let start = moment(work.mansione.richiesta.dataInizio).format("YYYY-MM-DD")
      let end = moment(work.mansione.richiesta.dataFine).format("YYYY-MM-DD")

      if(moment(today).isAfter(end))
          return -1
      if(moment(today).isBefore(start))
          return 1

      return 0

        // ritorna -1 se si è concluso, 0 se è in corso, 1 se è futuro

    },
    calculateStep(work){

      // se il progetto è finito ritorna false se la data di fine è oggi non è ancora finito

      // console.log("---------------------------------");
      // console.log("work.mansione.richiesta.dataFine --> ",work.mansione.richiesta.dataFine);
      // console.log("---------------------------------");

      // if( work.mansione.richiesta.dataFine && moment().isAfter(work.mansione.richiesta.dataFine) && moment().format("YYYY-MM-DD") != moment(work.mansione.richiesta.dataFine).format("YYYY-MM-DD")) {
      //   return {
      //       tag_text: "Progetto Concluso",
      //       tag_color: "#7E7E7E"
      //   }
      // }

      if(work.disponibilita == 4)
          return {
              tag_text: this.$t('Candidatura Ritirata'),
              tag_color: "#7E7E7E"
          }

      if( work.contrattoRicevuto)
          return {
              tag_text: this.$t('Confermato'),
              contratto_text: this.$t('Contratto'),
              tag_color: "#1CB967"
          }

      if( work.contratto)
          return {
              tag_text: this.$t('Confermato'),
              tag_color: "#1CB967",
              cta_text: this.$t('BEA ti ha inviato il contratto, controlla la tua posta e segui le istruzioni che trovi nella email.'),
              cta_color: "#FDD580",
              disable_btn: true
          }

      if( work.conferma == 1)
          return {
              tag_text: this.$t('Confermato'),
              tag_color: "#1CB967",
              cta_text: this.$t('La tua Candidatura per questo lavoro è stata confermata da BEA'),
              cta_color: "#76D4A3",
              disable_btn: true
          }
      
      if( work.conferma == 2)
          return {
              tag_text: this.$t('Non Confermato'),
              tag_color: "#FC0D1B",
              cta_text: this.$t('La tua Candidatura non è stata confermata per questo lavoro. BEA ti ringrazia par la tua disponibilità.'),
              cta_color: "#FD6D75",
              disable_btn: true
          }
        
      if( work.turniInviati == 2){
        switch(work.disponibilita){
            case 1: return {
                tag_text: this.$t('Disponibile'),
                tag_color: "#2D90D9",
                cta_text: this.$t('In attesa della conferma da parte di BEA'),
                cta_color: "#FDD580",
            }
            case 2: return {
                tag_text: this.$t('Non Disponibile'),
                tag_color: "#FC0D1B"
            }
            case 3: return {
                tag_text: this.$t('Faccio Sapere'),
                tag_color: "#FDBA2C",
                cta_text: this.$t('Conferma o disdici la tua disponibilità'),
                cta_color: "#FDD580",
            }
        }
    }

    let text = this.$t('Richiesta Disponibilità')
    let color = "#2CDCFC"
    if( work.disponibilita ){
      switch ( work.disponibilita ){
        case 1: text = this.$t('Disponibile')
                color = "#2D90D9"
          break;
        case 3: text = this.$t('Faccio Sapere')
                color = "#FDBA2C"
          break;
        case 2: text = this.$t('Non Disponibile')
                color = "#FC0D1B"
          break;
      }
    }

      return {
          tag_text: text,
          tag_color: color,
          cta_text: this.$t('Sei disponibile per questo lavoro?'),
          cta_color: "#2CDCFC",
      }
      

  },
    oreTotali(date){
        let result = 0

        if(!date)
            return result

        date.forEach(data => {
            data.turni.forEach(turno => {
                result += parseInt(turno.oreTotali.split(':')[0])
            })
        })

        return result
    },
    setLang(lang){
      localStorage.setItem('lang', lang);
    },
    euit(n, string="euit"){

      let it = n
      let eu = it - 4

      switch(string){
        case "it": return this.oddView(it)
        case "eu": return this.oddView(eu)
        case "euit": return "IT: " + this.oddView(it) + " / EU: " + this.oddView(eu)
      }


    },
    oddView(n){
      if(isNaN(n))
        return n
      return (n % 2 == 0) ? n : (parseInt(n)-1) + "/" + (parseInt(n)+1)
    },
    dd(i, name = "dd"){
      console.log(name,i);
      return i
    },
    logout() {
      this.$store.commit("user/logout")
      this.$store.dispatch("logout");
    },
    euro(val){
      return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(val)
    },
    cent_val(val){
      return Math.round(parseFloat(val ? val : 0) * 100) / 100
    },
    // showHeic(file){

    //   // return in base64
    //   return new Promise((resolve, reject) => {
    //     heic2any({
    //       blob: file,
    //       toType: "image/jpeg",
    //       quality: 0.5
    //     })
    //     .then((result) => {
    //       resolve(result)
    //     })
    //     .catch((e) => {
    //       reject(e)
    //     });
    //   })
    // },
    createUrl(file){
      const data = window.URL.createObjectURL(file);
      return data;
    },
    compensoNetto(compenso){
      return this.cent_val(compenso * 0.80)
    },
    async delay(time) {
      return new Promise(resolve => setTimeout(resolve, time));
    },
    infoDisponibilitaGenerale(disponibilita){

      let _return = { text: '*', color: 'grey' }

      switch(disponibilita){
        case 1: _return = { text: 'Disponibile', color: 'blue' };
        break;

        case 2:  _return =  { text: 'Non disponibile', color: 'red' };
        break;

        case 3:  _return =  { text: 'Faccio sapere', color: 'yellow' };
        break;

        case 4:  _return =  { text: 'Ritirata', color: 'black' };
        break;
      }

      return _return
    },
    infoDisponibilita(disponibilita){

      let _return = { text: '*', color: 'grey' }

      switch(disponibilita){
        case 1: _return = { text: 'Disponibile', color: 'blue' };
        break;

        case 0:  _return =  { text: 'Non disponibile', color: 'red' };
        break;

        case 2:  _return =  { text: 'Faccio sapere', color: 'yellow' };
        break;
        
      }

      return _return
    },
    typeContract(work){
      if(work.autoCandidata){
          return {
              color: 'green',
              text: "Auto Candidato"
          }
      }

      return {
          color: 'blue',
          text: "Candidato da Bea"
      }
    },
    getDocName(text){
      if(text){
        let arr = text.split("/")
        return arr[arr.length - 1]
      }

      return null
    },
    componeSrc(text){
      if(text)
        return process.env.VUE_APP_IMG_URL + text.replace(/^\/|\/$/g, '');
        // return process.env.VUE_APP_BACKEND_BASE_URL + "/getfile?url=/" + text.replace(/^\/|\/$/g, '');

      return null
    },
    today(formatDate = 'YYYY-MM-DD'){
      let _today = moment().format(formatDate)
      return _today
    },
    tomorrow(formatDate = 'YYYY-MM-DD'){
      let _tomorrow = moment().add(1,'day').format(formatDate)
      return _tomorrow
    },
    formatDate(date, formatDate = 'DD/MM/YYYY') {
      return moment(date).format(formatDate)
    },
    calculateAge(date) {
      return moment().diff(moment(date, "DD/MM/YYYY"), 'years')
    },
    toggleArrayItem(array, value){
      if(array.includes(value)){
          array = array.filter(el => el != value)
      } else {
          array.push(value)
      }
      return array
    },
    toggleArrayObject(array, value, key = 'id'){
      if(array.find(el => el[key] == value[key])){
          array = array.filter(el => el[key] != value[key])
      } else {
          array.push(value)
      }
      return array
    },
    afterDate(date, date2) {
      if(date2)
        return moment(date).isAfter(date2);
        
      return moment(date).isAfter(moment().format("YYYY-MM-DD"));

    },
    beforeDate(date, date2) {
      if(date2)
        return moment(date).isBefore(date2);
        
      return moment(date).isBefore(moment().format("YYYY-MM-DD"));

    },
    view_taglia(taglia){
        let _string = (taglia % 2 == 1) ? ((taglia-1) + "/" + (taglia+1)) : taglia
        return _string
    },
    indirizzo(user, n){
        let string = "**é**"

        string = string + (user["indirizzo" + n] ? (user["indirizzo" + n]) : '')
        string = string + (user["cap" + n] ? (', ' + user["cap" + n]) : '')
        string = string + (user["citta" + n] ? (', ' + user["citta" + n]) : '')
        string = string + (user["provincia" + n] ? (', ' + user["provincia" + n]) : '')
        string = string + (user["regione" + n] ? (', ' + user["regione" + n]) : '')
        string = string + (user["stato" + n] ? (', ' + user["stato" + n]) : '')

        string = string.replace("**é**,", "")
        string = string.replace("**é**", "")

        return string

    },
    calculateMansionFeeMax(proposal, nl = 'netto/lordo', total = false){
        
        let _proposal = JSON.parse(JSON.stringify(proposal))
  
        if(!_proposal || !_proposal.date || !_proposal.date.length)
          return 0
  
        const sommaCompensoTurni = _proposal.date.reduce((acc, obj) => {
          obj.turni.forEach(turno => {
            acc += turno.compensoTurno;
          });
          return acc;
        }, 0);
  
        let fee
  
        if(!total){
          if(!_proposal.result)
            return 0
    
          let hours = _proposal.result.replace(" ore","")
          hours = parseFloat(hours) ? parseFloat(hours) : 1
    
          fee = this.cent_val(sommaCompensoTurni / hours)
        } else {
          fee = sommaCompensoTurni
        }
  
        switch(nl){
          case "netto": return this.euro(fee * 0.8)
          case "lordo": return this.euro(fee)
          default: return this.euro(fee * 0.8) + " / " + this.euro(fee)
        }
      },
    calculateMansionFee(proposal, nl = 'netto/lordo', total = false){


      let _proposal = JSON.parse(JSON.stringify(proposal))

      if(!_proposal || !_proposal.date || !_proposal.date.length)
        return 0

      const sommaCompensoTurni = _proposal.date.reduce((acc, obj) => {
        obj.turni.forEach(turno => {
          acc += turno.compensoTurno;
        });
        return acc;
      }, 0);

      let fee

      if(!total){
        if(!_proposal.result)
          return 0
  
        let hours = _proposal.result.replace(" ore","")
        hours = parseFloat(hours) ? parseFloat(hours) : 1
  
        fee = this.cent_val(sommaCompensoTurni / hours)
      } else {
        fee = sommaCompensoTurni
      }

      switch(nl){
        case "netto": return this.euro(fee * 0.8)
        case "lordo": return this.euro(fee)
        default: return this.euro(fee * 0.8) + " / " + this.euro(fee)
      }
      

    }
  },
  created () {
    setTimeout(() => this.delay_mounted_1000 = true, 1000);
  },
});